"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ruleSubject;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _sortBy = _interopRequireDefault(require("lodash/fp/sortBy"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _pipeP = _interopRequireDefault(require("../utils/pipeP"));

var _reduceError = _interopRequireDefault(require("../utils/reduceError"));

var _ruleApplicable = _interopRequireDefault(require("../utils/ruleApplicable"));

var _markApplicable = _interopRequireDefault(require("../utils/markApplicable"));

var _makeMap = _interopRequireDefault(require("../utils/makeMap"));

var _calcValueAdded = _interopRequireDefault(require("../utils/calcValueAdded"));

var _resolveAndCallStrategy = _interopRequireDefault(require("../resolveAndCallStrategy"));

var _arrayMergeUnique = _interopRequireDefault(require("../utils/arrayMergeUnique"));

var createLog = function createLog(subject, subjectIndex, applicableRules, other) {
  return (0, _extends2.default)({
    subjectIndex: subjectIndex,
    subjectProduct: subject.product
  }, other, {
    applicableRules: applicableRules,
    applicableRuleCodes: applicableRules.map(function (i) {
      return i.rule.ruleCode;
    }),
    applicableRuleThreads: applicableRules.map(function (i) {
      return i.rule.ruleThread;
    })
  });
};

var applyRuleOnSubject = function applyRuleOnSubject(ctx, subject) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(rule) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _pipeP.default)((0, _ruleApplicable.default)(ctx, rule), (0, _markApplicable.default)(ctx, rule), (0, _makeMap.default)(ctx, rule), (0, _calcValueAdded.default)(ctx, rule))(subject));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var applyAllRulesOnSubject = function applyAllRulesOnSubject(ctx, rules) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(subject, subjectIndex) {
      var rulesToInspect, _yield$Promise$all$re, _yield$Promise$all$re2, errs, toFindWinnerIn, err, applicableRules, _ref7, _ref8, winner, nextSubject;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (subject.ruleFootprint) {
                _context3.next = 4;
                break;
              }

              _context3.t0 = // subject is not marked take all rules to inspect
              rules;
              _context3.next = 7;
              break;

            case 4:
              _context3.next = 6;
              return rules.reduce( /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(rls, rule) {
                  var isForce;
                  return _regenerator.default.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!Array.isArray(rule.forceThreadFootprint)) {
                            _context2.next = 6;
                            break;
                          }

                          _context2.next = 3;
                          return (0, _resolveAndCallStrategy.default)(ctx, 'forceThreadFootPrint', rule.forceThreadFootprint, rule, subject);

                        case 3:
                          _context2.t0 = _context2.sent;
                          _context2.next = 7;
                          break;

                        case 6:
                          _context2.t0 = !!rule.forceThreadFootprint;

                        case 7:
                          isForce = _context2.t0;
                          return _context2.abrupt("return", isForce && subject.ruleFootprint.ruleThread === rule.ruleThread ? [].concat((0, _toConsumableArray2.default)(rls), [rule]) : rls);

                        case 9:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x4, _x5) {
                  return _ref3.apply(this, arguments);
                };
              }(), []);

            case 6:
              _context3.t0 = _context3.sent;

            case 7:
              rulesToInspect = _context3.t0;

              if (!(rulesToInspect.length === 0)) {
                _context3.next = 10;
                break;
              }

              return _context3.abrupt("return", [null, subject, createLog(subject, subjectIndex, [], subject.ruleFootprint ? {
                subjectWithFootprint: subject.ruleFootprint
              } : {
                subjectNoRulesDefined: true
              })]);

            case 10:
              _context3.next = 12;
              return Promise.all(rulesToInspect.map(applyRuleOnSubject(ctx, subject)));

            case 12:
              _yield$Promise$all$re = _context3.sent.reduce(function (r, _ref4) {
                var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
                    err = _ref5[0],
                    resultCtx = _ref5[1];

                return [[].concat((0, _toConsumableArray2.default)(r[0]), [err]), resultCtx ? [].concat((0, _toConsumableArray2.default)(r[1]), [resultCtx]) : r[1]];
              }, [[], []]);
              _yield$Promise$all$re2 = (0, _slicedToArray2.default)(_yield$Promise$all$re, 2);
              errs = _yield$Promise$all$re2[0];
              toFindWinnerIn = _yield$Promise$all$re2[1];
              err = (0, _reduceError.default)(errs);

              if (!err) {
                _context3.next = 19;
                break;
              }

              return _context3.abrupt("return", [err]);

            case 19:
              // najdi vitaza a v logu ho oznac
              applicableRules = (0, _sortBy.default)([function (wc) {
                return wc.valueAdded;
              }], toFindWinnerIn).map(function (_ref6, idx) {
                var applicableRule = _ref6.applicableRule,
                    restOfRule = (0, _objectWithoutProperties2.default)(_ref6, ["applicableRule"]);
                return (0, _extends2.default)({
                  rule: applicableRule
                }, restOfRule, idx === 0 ? {
                  winner: true
                } : {});
              });
              _ref7 = applicableRules.length === 0 ? [null, subject] : function (_ref9) {
                var _ref10 = (0, _slicedToArray2.default)(_ref9, 1),
                    w = _ref10[0];

                return [w, (0, _deepmerge.default)(subject, w.partial, {
                  arrayMerge: _arrayMergeUnique.default
                })];
              }(applicableRules), _ref8 = (0, _slicedToArray2.default)(_ref7, 2), winner = _ref8[0], nextSubject = _ref8[1];
              return _context3.abrupt("return", [null, nextSubject, createLog(subject, subjectIndex, applicableRules, {
                winner: winner
              })]);

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

function ruleSubject(_x6, _x7) {
  return _ruleSubject.apply(this, arguments);
}

function _ruleSubject() {
  _ruleSubject = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(ctx, rules) {
    var subjects, _yield$Promise$all$re3, _yield$Promise$all$re4, err, nextSubjects, log;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            subjects = ctx.cart.subjects;
            _context4.next = 3;
            return Promise.all(subjects.map(applyAllRulesOnSubject(ctx, rules)));

          case 3:
            _yield$Promise$all$re3 = _context4.sent.reduce(function (_ref11, _ref12) {
              var _ref13 = (0, _slicedToArray2.default)(_ref11, 3),
                  errsRed = _ref13[0],
                  subjectsRed = _ref13[1],
                  logRed = _ref13[2];

              var _ref14 = (0, _slicedToArray2.default)(_ref12, 3),
                  itemErr = _ref14[0],
                  itemSubject = _ref14[1],
                  itemLog = _ref14[2];

              return [[].concat((0, _toConsumableArray2.default)(errsRed), [itemErr]), [].concat((0, _toConsumableArray2.default)(subjectsRed), [itemSubject]), (0, _extends2.default)({}, logRed, {
                subjects: [].concat((0, _toConsumableArray2.default)(logRed.subjects), [itemLog]),
                applicableRules: [].concat((0, _toConsumableArray2.default)(logRed.applicableRules), (0, _toConsumableArray2.default)(itemLog.applicableRules)),
                applicableRuleCodes: [].concat((0, _toConsumableArray2.default)(logRed.applicableRuleCodes), (0, _toConsumableArray2.default)(itemLog.applicableRuleCodes)),
                applicableRuleThreads: [].concat((0, _toConsumableArray2.default)(logRed.applicableRuleThreads), (0, _toConsumableArray2.default)(itemLog.applicableRuleThreads))
              })];
            }, [[], [], {
              groupType: 'subject',
              subjects: [],
              applicableRules: [],
              applicableRuleCodes: [],
              applicableRuleThreads: []
            }]);
            _yield$Promise$all$re4 = (0, _slicedToArray2.default)(_yield$Promise$all$re3, 3);
            err = _yield$Promise$all$re4[0];
            nextSubjects = _yield$Promise$all$re4[1];
            log = _yield$Promise$all$re4[2];
            return _context4.abrupt("return", [(0, _reduceError.default)(err), (0, _extends2.default)({}, ctx, {
              cart: (0, _extends2.default)({}, ctx.cart, {
                subjects: nextSubjects
              })
            }), log]);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _ruleSubject.apply(this, arguments);
}